import { format as dateFnsFormat, parseISO } from 'date-fns';

/**
 * Format a date string to a readable format
 */
export function formatDate(date: string | null | undefined, format = 'MMM dd, yyyy'): string {
  if (!date) return '-';
  try {
    return dateFnsFormat(parseISO(date), format);
  } catch {
    return date;
  }
}

/**
 * Format a date to ISO string
 */
export function formatDateISO(date: Date | string | null | undefined): string | null {
  if (date === null || date === undefined) return null;
  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    const isoString = dateObj.toISOString();
    const datePart = isoString.split('T')[0];
    return datePart ?? null;
  } catch {
    return null;
  }
}

/**
 * Format currency amount
 */
export function formatCurrency(amount: number | null | undefined): string {
  if (amount === null || amount === undefined) return '-';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}

/**
 * Format currency amount without decimals if not needed
 */
export function formatCurrencyNoDecimals(amount: number | null | undefined): string {
  if (amount === null || amount === undefined) return '-';
  // Check if amount has decimal places
  const hasDecimals = amount % 1 !== 0;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: hasDecimals ? 2 : 0,
  }).format(amount);
}

/**
 * Removes category-specific suffixes from component names
 * Examples:
 * - "27" Screen (Amazon) for Quick Checkout" -> "27" Screen (Amazon)"
 * - "27" Screen (Amazon) for Category Station" -> "27" Screen (Amazon)"
 * - "27" Screen (Amazon) for Branded Station" -> "27" Screen (Amazon)"
 */
export function cleanComponentName(name: string): string {
  // Remove category-specific suffixes
  return name
    .replace(/\s+for\s+Quick\s+Checkout\s*$/i, '')
    .replace(/\s+for\s+Category\s+Station\s*$/i, '')
    .replace(/\s+for\s+Branded\s+Station\s*$/i, '')
    .replace(/\s+for\s+Flower\s+Station\s*$/i, '')
    .replace(/\s+for\s+Menu\s+Board\s*$/i, '')
    .trim();
}

